import type { PapiAttachmentFile } from '@wix/da-papi-types';
import { IMAGE_MIME, VIDEO_MIME } from '@wix/da-shared-react/pkg/utils/mime';

export function getAdditionalAttachmentType(
  isMultiVideo: boolean
): 'additional_image' | 'additional_media' {
  return isMultiVideo ? 'additional_media' : 'additional_image';
}

export function getAdditionalAttachmentAcceptedMimeTypes(isMultiVideo: boolean): string[] {
  return isMultiVideo ? [...IMAGE_MIME, ...VIDEO_MIME] : [...IMAGE_MIME];
}

export function getIsVideoAttachment(attachment: PapiAttachmentFile): boolean {
  return attachment.type === 'video';
}
